import { Typography } from "@mui/material";
import { useCountdown } from "hooks/timers/useCountdown";
import { useTranslation } from "react-i18next";

/**
 * Timer that displays information about when the fridge will lock itself
 * @param lockTimeout
 * @param onTimeout callback invoked when the timer reaches zero
 * @constructor
 */
export const AutolockTimer = ({ lockTimeout, onTimeout }: { lockTimeout: number; onTimeout?: () => void }) => {
	const { countdown } = useCountdown(lockTimeout, onTimeout);
	const { t } = useTranslation();

	if (countdown > 0) {
		return (
			<Typography variant="h5" color="white" fontWeight={500}>
				{t("order.step2.autolock", { countdown: countdown })}
			</Typography>
		);
	}
	return null;
};
